import { CompactUserResponse } from '@business/entities/account';
import { FolderBreadcrumbResponse } from '../file/FolderResponse';

export type MediaFolderId = string;
export type MediaId = string;

export interface MediaItemResponse {
  breadcrumbs: FolderBreadcrumbResponse[];
  items: (MediaFolderResponse | MediaResponse)[];
}

export enum MediaItemType {
  folder = 'folder',
  media = 'media',
}

export interface CompactMediaFolderResponse {
  id: MediaFolderId;
  name: string;
  mediaType: MediaItemType;
  user: CompactUserResponse;
  items: number;
  folderId: MediaFolderId;
  createdAt: number;
  updatedAt: number;
}

export interface MediaFolderResponse extends CompactMediaFolderResponse {
  breadcrumbs: FolderBreadcrumbResponse[];
}

export interface MediaResponse {
  id: MediaId;
  name: string;
  mediaType: MediaItemType;
  folderId: MediaFolderId;
  type: MediaType;
  hashUrl: string;
  hashKey: string;
  url: string;
  filePath: string;
  fileName: string;
  size: number;
  clicks: number;
  createdAt: number;
  updatedAt: number;
  breadcrumbs: FolderBreadcrumbResponse[];
}

export enum MediaType {
  url = 'url',
  file = 'file',
}

export type MediaRequest = {
  name: string;
  type: string;
  url: string;
  files?: File[];
};

export type CompactMediaResponse = Pick<MediaResponse, 'id' | 'name' | 'filePath'> & { parentFolderId?: MediaFolderId };
